<template>
  <QuickAddBox :config="config" />
</template>

<script>
import QuickAddBox from "../../components/QuickAddBox/QuickAddBox.vue";

export default {
  name: "app",
  components: {
    QuickAddBox
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
